"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTapeBuilderNodeGraph = void 0;
const common_1 = require("@finley-technologies/common");
const uiNodes_1 = require("../uiNodes/uiNodes");
const validateTapeBuilderNodeGraph = ({ graph, }) => {
    //
    // we will do any generic graph validations here
    // and then ask each node to validate itself.
    //
    const { nodes } = graph;
    const errors = [];
    //
    // all graph nodes have unique tapeBuilderNodeId
    //
    const tapeBuilderNodeIds = nodes.map((node) => node.metadata.tapeBuilderNodeId);
    const uniqueTapeBuilderNodeIds = new Set(tapeBuilderNodeIds);
    if (tapeBuilderNodeIds.length !== uniqueTapeBuilderNodeIds.size) {
        errors.push(`All graph nodes must have unique tapeBuilderNodeId. Found ${tapeBuilderNodeIds.join(',')}`);
    }
    //
    // all raw nodes must have unique externalFilename
    //
    const externalFileNames = nodes
        .map((node) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(node.metadata.tapeBuilderNodeType);
        // we are checking for !isFinal below because
        // we have a node (configTape) that is raw && isFinal
        // only nodes marked as raw and not final can be narrowed by typescript to have
        // getExternalFilename. TODO: fix this so that getExternalFilename is not tied to isRaw
        return !uiNode.isOperation && uiNode.isRaw && !uiNode.isFinal
            ? uiNode.getExternalFilename(node)
            : null;
    })
        .filter(common_1.typeguards.isNotNullOrUndefined);
    const uniqueExternalFileNames = new Set(externalFileNames);
    if (externalFileNames.length !== uniqueExternalFileNames.size) {
        errors.push(`All raw nodes must have unique externalFilename. Found ${externalFileNames.join(',')}`);
    }
    //
    // all tape nodes must have unique artifactSlug
    //
    const slugs = nodes
        .map((node) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(node.metadata.tapeBuilderNodeType);
        return uiNode.isOperation ? null : uiNode.getArtifactSlug(node);
    })
        .filter(common_1.typeguards.isNotNullOrUndefined);
    const uniqueSlug = new Set(slugs);
    if (slugs.length !== uniqueSlug.size) {
        errors.push(`All tape nodes must have unique artifactSlug. Found ${slugs.join(',')}`);
    }
    const getUINode = (node) => (0, uiNodes_1.getUINodeByType)(node.metadata.tapeBuilderNodeType);
    // let node implementations valiate their own config.
    nodes.forEach((node) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(node.metadata.tapeBuilderNodeType);
        const nodeErrors = uiNode.hasValidConfig({ graph, node, getUINode });
        errors.push(...nodeErrors);
    });
    return errors;
};
exports.validateTapeBuilderNodeGraph = validateTapeBuilderNodeGraph;
//# sourceMappingURL=validateTapeBuilderNodeGraph.js.map